import { Card, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Star, User } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Product } from "@/types/product";

interface ProductCardProps {
  product: Product;
}

const ProductCard = ({ product }: ProductCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <Card 
      className="overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer"
      onClick={handleClick}
    >
      <div className="aspect-square relative">
        <img
          src={product.image_url || "/placeholder.svg"}
          alt={product.name}
          className="object-cover w-full h-full"
        />
      </div>
      <CardHeader className="p-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between">
            <p className="text-sm text-muted-foreground">{product.brand}</p>
            {product.user_id && (
              <Button
                variant="ghost"
                size="sm"
                className="flex items-center gap-1"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/user/${product.user_id}`);
                }}
              >
                <User className="w-4 h-4" />
              </Button>
            )}
          </div>
          <h3 className="font-semibold">{product.name}</h3>
          <div className="flex items-center gap-2">
            <div className="flex items-center">
              <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              <span className="ml-1 text-sm font-medium">{product.rating || 0}</span>
            </div>
            <span className="text-sm text-muted-foreground">
              ({product.reviews_count || 0} {t('products.reviews')})
            </span>
          </div>
          <p className="text-sm font-medium mt-2">
            ${product.price}
          </p>
        </div>
      </CardHeader>
    </Card>
  );
};

export default ProductCard;